import axios from 'axios'
import { callWaiter } from 'redux-waiter'
import { isDevelopment, isStg } from 'modules/app-config/environment'
import { STG_ENV } from 'modules/app-config/stg-env'
import apiClient from 'enrollment-platform/api/enrollment-platform-client/api-client'
import { getWexVcnTransactions } from 'enrollment-platform/api/vcn'
import {
  ENROLLME_SOURCE_SYSTEM,
  CALLER,
  EMPLOYEE_CARD_UPDATE,
  GET_TRANSACTIONS,
} from '../../constants'
import { combineAndSortTransactions } from './mergeVcTransactions'

const getVcnBasePath = () => {
  if (isStg()) {
    return STG_ENV.vcnServiceUrl
  }
  if (isDevelopment()) {
    return 'https://vcn-service.dev.surecolabs.com'
  }
  return 'https://vcn-service.docday.com'
}

export const VCN_BASE_PATH = getVcnBasePath()

const axiosConfig = () => ({
  baseURL: VCN_BASE_PATH,
})

const postRequest = ({ url, data, params }) =>
  axios({
    ...axiosConfig(),
    method: 'post',
    url,
    data,
    params,
  }).then((response) => response.data)

const getRequest = ({ url, params }) =>
  axios({
    ...axiosConfig(),
    method: 'get',
    url,
    params,
  }).then((response) => response.data)

const getAchIstreamTransactions = (benefitId) =>
  apiClient
    .get(`/payment-transaction/istream/${encodeURIComponent(benefitId)}`)
    .then((response) => response.data)

export const getCardState = ({ userId }) =>
  axios.get(
    `${VCN_BASE_PATH}/card/paymentuser/sourcesystem/${ENROLLME_SOURCE_SYSTEM}/sourceuserid/${userId}/cardStatus`
  )

export const getCardDetails = () => {
  axios.post(`${VCN_BASE_PATH}/card/showdetails`)
}

export const performCardAction =
  ({
    Action,
    cardId,
    reason = 'User Action',
    personId: sourceUserId,
    benefitId,
  }) =>
  (dispatch) =>
    dispatch(
      callWaiter(EMPLOYEE_CARD_UPDATE, {
        requestCreator: () =>
          postRequest({
            url: `/card/${Action}`,
            data: {
              card_public_key: cardId,
              reason,
              source_user_id: sourceUserId,
              caller_name: CALLER,
              source_system_id: ENROLLME_SOURCE_SYSTEM,
            },
            params:
              Action === 'terminate' && benefitId ? { benefitId } : undefined,
          }),
      })
    )

/**
 * Marqeta timeline from VCN-service plus optional WEX EPS merged timeline (same benefit may have both).
 *
 * @param {string} benefitId application / benefit public key used by VCN-service
 * @param {{ merchantLogId?: string }} [options] when set, also loads `GET .../vcn/wex/:merchantLogId/transactions`
 */
export const getTransactions =
  (benefitId, options = {}) =>
  (dispatch) => {
    const { merchantLogId } = options
    return dispatch(
      callWaiter(GET_TRANSACTIONS, {
        requestCreator: async () => {
          const marqetaPromise = getRequest({
            url: `/card/transactions/sourcePublicKey/${benefitId}`,
          }).catch(() => ({ transactions: [] }))

          const wexPromise =
            merchantLogId != null && merchantLogId !== ''
              ? getWexVcnTransactions(merchantLogId).catch(() => ({
                  mergedTransactions: [],
                }))
              : Promise.resolve({ mergedTransactions: [] })

          const achPromise = getAchIstreamTransactions(benefitId).catch(
            () => []
          )

          const [marqetaRes, wexRes, achRes] = await Promise.all([
            marqetaPromise,
            wexPromise,
            achPromise,
          ])

          return {
            transactions: combineAndSortTransactions(
              marqetaRes,
              wexRes,
              achRes
            ),
          }
        },
      })
    )
  }

export default {
  performCardAction,
  getTransactions,
}
